"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHouseBlockFilled = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 18 18",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "hbfa",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1440 0v1892H0V0h1440Z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "hbfb",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M15 0v18H0V0h15ZM6.5 12h-2v2h2v-2Zm4 0h-2v2h2v-2Zm-4-4h-2v2h2V8Zm4 0h-2v2h2V8Zm-4-4h-2v2h2V4Zm4 0h-2v2h2V4Z"
      })
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    clipPath: "url(#hbfa)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#hbfb)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0 0h15v18H0V0z"
      })
    })
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconHouseBlockFilled')(IconHouseBlockFilled);